import React from "react";
import panelStyles from "../../styles/Panel.module.css";
import analyticsStyles from "../../styles/Analytics.module.css";
import { PRODUCT_GROUP_LABELS } from "../../constants";
import { formatProductCell } from "../../utils/analyticsFormatters";

export function AnalyticsProductsBlock({ day, week, month }) {
  return (
    <div className={analyticsStyles.block}>
      <h3>Продажи по продуктам</h3>
      <div className={panelStyles.tableWrap}>
        <table className={panelStyles.table}>
          <thead>
            <tr>
              <th>Продукт</th>
              <th>День</th>
              <th>Неделя</th>
              <th>Месяц</th>
            </tr>
          </thead>
          <tbody>
            {PRODUCT_GROUP_LABELS.map((group) => (
              <tr key={`product-${group.key}`}>
                <td>{group.label}</td>
                <td>{formatProductCell(day, group.key)}</td>
                <td>{formatProductCell(week, group.key)}</td>
                <td>{formatProductCell(month, group.key)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={panelStyles.note}>Количество покупок и выручка по группам продуктов.</div>
    </div>
  );
}

export default AnalyticsProductsBlock;
